<template>
    <div class='tbjm twoBox' v-if='tbdwmc'>
        <div class="redBox">
            <p class='red' v-if='!isBegin'>解密未开始</p>
            <div v-else>
                <p>解密剩余时间</p>
                <myClock class='small lf' :shenyu='shenyu' :key='shenyu' cId='c1'></myClock>
            </div>
        </div>
        <div class="box">
            <table class='show'>
                <colgroup width='160px'></colgroup>
                <tr>
                    <td>投标单位</td>
                    <td>{{tbdwmc}}</td>
                </tr>
                <tr>
                    <td>解密时间</td>
                    <td>
                        <span v-html="jmsj" style="margin-right:20px"></span>
                        <el-button v-if='sfjmsb&&shenyu>0&&!sqbjzt' type="primary" @click='sqbj' :disabled="waitLoading">申请补救</el-button>
                        <el-button v-if='sqbjzt&&shenyu>0&&sfjmsb' type="primary" @click='bj'>上传补救文件</el-button>
                    </td>
                </tr>
            </table>
            <div class='btnBox' style='margin-top:40px'>
                <el-button type="primary"  @click='getPfjgTabs' v-if='sfeckb' :disabled="waitLoading">显示评分结果</el-button>
            </div>

        </div>
        <!-- 弹窗 -->
        <el-dialog :visible.sync="visible" width="1100px" title="解密" v-if='visible' :close-on-click-modal="false" :show-close="!progress? true : progressData.decryptStatus != 0 ? true :  false " @close="closeDialog" >
            <jmCom ref='jmCom' @Qd='saveJm' @ewmQd='ewmQd' @bj='bj' :jm='sqbjzt' @sqbj='sqbj' @refreshJmzt="handleSetNewJmzt" @closeCaDialog="visible = false" :list='list' :sfApp='sfApp'></jmCom>
        </el-dialog>
        <!-- 补救 -->
        <el-dialog
            title="补救"
            :visible.sync="dialogBj"
            width="780px"
            :close-on-click-modal="false"
            >
            <div class='bjBox'>
                <div class='clear'>
                    <globalUploader :disabled="uploadFlag" @fileAdded='fileAdded' @fileSuccess='fileSuccess'></globalUploader>
                </div>
            </div>
            <div class="btnBox">
                <el-button type="primary" @click="saveBj" :disabled="!bidfilesId||waitLoading">补救</el-button>
                <el-button type="primary" @click="dialogBj=false;waitLoading=false">返回</el-button>
            </div>
        </el-dialog>
        <!-- 评分结果 -->
        <el-dialog
            title="评分结果"
            :visible.sync="pfjgDialog"
            width="980px"
            :close-on-click-modal="false"
            >
            <div style="display: flex;justify-content: end;">
                <el-button @click="refresh" v-if="sfchjy">刷新</el-button>
            </div>
            <div v-if="sfchjy">
                        <el-table
                            ref="pfjgList"
                            border
                            :data="chjyTableData"
                            style="width: 100%"
                            empty-text='评审未完成，请稍等。。'
                        >
                            <el-table-column
                              v-for="(item, index) in chjyTableHead"
                              :key="index"
                              :prop="item.prop"
                              :label="item.label"
                            >
                            </el-table-column>
                        </el-table>
                        <div class="clear">
                        <span class="lf pageNum">共{{pfjgTotal}}家。</span>
                        <myPage
                        class="rt"
                        :total="pfjgTotal"
                        :page-size="10"
                        :currentPage="pfjgPage"
                        @changePage="changePfjgPage"
                        ></myPage>
                    </div>
                    </div>
                    <div v-else>
            <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane v-for='item in pfjgTabs' :label="item.psmc" :name="item.lx" :key='item.lx'>
                    <el-table
                        ref="pfjgList"
                        border
                        :data="pfjgList"
                        style="width: 100%"
                        empty-text='评审未完成，请稍等。。'
                    >
                        <el-table-column type="index" label="序号" width="50">
                            <template slot-scope="scope">{{(pfjgPage - 1) * 10 + scope.$index + 1}}</template>
                        </el-table-column>
                        <el-table-column prop="tbdwmc" label="投标单位名称"  min-width="120" show-overflow-tooltip>
                        </el-table-column>
                        <el-table-column prop="df" label="得分"  width="80"></el-table-column>
                        <el-table-column prop="sfyx" label="有效"  width="80"></el-table-column>
                        <el-table-column prop="bz" label="备注" min-width="120"></el-table-column>
                    </el-table>
                    <div class="clear">
                        <span class="lf pageNum">共{{pfjgTotal}}家。</span>
                        <myPage
                        class="rt"
                        :total="pfjgTotal"
                        :page-size="10"
                        :currentPage="pfjgPage"
                        @changePage="changePfjgPage"
                        ></myPage>
                    </div>
                </el-tab-pane>
            </el-tabs>
            </div>
            <div class="btnBox">
                <el-button type="primary" @click="dcbb" :disabled="waitLoading"
                >导出报表</el-button>
                <el-button type="primary" @click="pfjgDialog=false;waitLoading=false">确认</el-button>
            </div>
        </el-dialog>
    </div>
    <div v-else class='loading'>
        <p>正在进行有效性审查，请耐心等待...</p>
        <div id="colorfulPulse">
            <span class='item-1'></span>
            <span class='item-2'></span>
            <span class='item-3'></span>
            <span class='item-4'></span>
            <span class='item-5'></span>
            <span class='item-6'></span>
            <span class='item-7'></span>
        </div>
    </div>
</template>
<script>
import myClock from '../components/clock/clock'
import jmCom from '../components/jmCom'
import myPage from '../components/page'
import globalUploader from '../components/upload/uploader'
export default {
    name:'tbjm',
    props:['djlcId'],
    components:{
        myClock,jmCom,myPage,globalUploader
    },
    data(){
        return{
            waitLoading:false,
            isBegin:false,
            shenyu:0,
            tbdw:{},
            tbdwmc:'',
            jmsj:'',
            visible:false,
            intervalTbjm:null,
            jgdm:'',
            dialogBj:false,//补救弹窗
            uploadFlag:false,//上传按钮是否禁用
            tbwjId:'',
            bidfilesId:'',//保存补救时要用
            sqbjzt:false,
            sfjmsb:false,//是否解密失败
            list:[],
            sfApp:'',
            sfeckb:false,//是否二次开标，显示评分按钮是否显示
            pfjgDialog:false,
            pfjgTabs:[],
            activeName:'',//评分结果类型
            pfjgList:[],
            pfjgPage:1,
            pfjgTotal:0,
            parentJm:'',
            progressData:{
                decryptStatus:0,
                total:0,
                lastCount:0
            },
            progress:false,
            progressInterval:null,
            getObj:{}, // 用于临时存储解密进度条的传参
            timer: null,
            sfchjy: false, // 长湖监狱
            chjyTableHead: [],
            chjyTableData: []
        }
    },
    computed:{
        percentage(){
            return this.progressData.total !== -1 ? this.progressData.total==0 ? 0: ((this.progressData.total - this.progressData.lastCount)/this.progressData.total).toFixed(2)*100 : 100
        },
    },
    watch: {
        pfjgDialog(newVal) {
            if (newVal && this.sfchjy) {
            // 打开弹窗时启动定时器
            this.timer = setInterval(() => {
              this.refresh();
            }, 15000);
            } else {
                // 关闭弹窗时清除定时器
                if (this.timer) {
                  clearInterval(this.timer);
                  this.timer = null;
                }
            }
        }
    },
    methods:{
      /**
       * 刷新步骤的解密状态
       */
        handleSetNewJmzt() {
          let obj={
            lx:'tb',
            data:{
              index:2,
              msg:'2',
              all:true
            }
          }
          this.$emit('send',JSON.stringify(obj));
          this.getData();
        },
        closeDialog(){
            this.visible = false
            clearInterval(this.progressInterval)
            this.progressInterval = null
            if(this.progressData.decryptStatus == 2){ // 若失败则数据清空
                this.progressData = {
                    decryptStatus:0,
                    total:0,
                    lastCount:0
                }
                this.progress = false,
                this.getObj = {}
            }
        },
        getData(){
            let para={
                djlcId:this.djlcId
            }
            this.$api.tbdwJmTbr(para).then(res=>{
                if(res.data.meta.success){
                    this.sfeckb=res.data.data.xsbb;
                    this.tbdw=res.data.data.tbdw;
                    this.sqbjzt=res.data.data.tbdw.sqbj=="2"?true:false
                    this.tbdwmc=res.data.data.tbdw.fcqymc;
                    this.parentJm = res.data.data.tbdw.jmzt
                    this.sfjm=res.data.data.tbdw.jmzt!='0'?true:false;//是否已经操作过解密
                    this.sfjmsb=res.data.data.tbdw.jmzt=='2'?true:false;//是否已经解密并且失败
                    this.sfApp=res.data.data.sfApp;
                    this.sfchjy = res.data.data.sfchjy
                    this.list.push(res.data.data.tbwj)
                    if(res.data.data.sfszjmsj!==''){
                        this.shenyu=res.data.data.sfszjmsj;
                        this.isBegin=true;
                        if(this.shenyu>=1000){
                            if(this.sfjm){
                                if(this.sfjmsb){
                                    this.jmsj='<span class="red">解密失败</span>';
                                }else{
                                    this.jmsj=res.data.data.tbdw.jmsj?this.$moment(res.data.data.tbdw.jmsj).format("YYYY-MM-DD HH:mm:ss"):'';
                                }
                            }else{
                                this.jmsj='';
                                this.tbjmshenyuFun();
                            }
                        }else{
                            //签到倒计时结束
                            if(this.sfjm){
                                if(this.sfjmsb){
                                    this.jmsj='<span class="red">解密失败</span>'
                                }else{
                                    this.jmsj=this.$moment(res.data.data.tbdw.jmsj).format("YYYY-MM-DD HH:mm:ss");
                                }
                            }else{
                                this.jmsj='<span class="red">未解密</span>'
                            }
                        }
                    }else{
                        this.isBegin=false;
                        this.shenyu=0;
                    }


                }else{
                    this.$message({
                        type:'error',
                        message:res.data.meta.message
                    })
                }
            }).catch(()=>{})
        },
        //投标人点击解密按钮操作
        tbrDo(lx){
            if(lx=='tbjm'){
                this.visible=true;
                if(this.progress){
                    this.tbdwJmDetail(this.getObj)
                }
            }
        },
        async tbdwJmDetail(obj){
            let params = {
                jgdm:obj.jgdm,
                jmmw:obj.jmmw,
                sftbr:true,
                caNo:obj.caNo
            }
            this.getObj = obj
            this.$api.tbdwJmDetail(params).then(res=>{
                this.progressData = res.data.data
                this.progressData.decryptStatus = Number(this.progressData.decryptStatus)
                if(this.progressData.decryptStatus == 1){
                    clearInterval(this.progressInterval);
                    clearInterval(this.intervalTbjm);
                    this.intervalTbjm=null;
                    this.progressInterval=null
                    let obj={
                        lx:'tb',
                        data:{
                            index:2,
                            msg:'2',
                            all:true
                        }
                    }
                    this.$emit('send',JSON.stringify(obj));
                    this.getData();
                }
            })
        },
        //保存解密成功
        saveJm(obj){
            this.$refs.jmCom.waitLoading = true
            let para={
                jgdm:obj.jgdm,
                jmmw:obj.jmmw,
                sftbr:true,
                caNo:obj.caNo
            }
            this.waitLoading=true
            this.$api.checkJm(para).then(res=>{
                if(res.data.meta.success){
                    this.progress = true
                    this.tbdwJmDetail(obj)
                    this.progressInterval = setInterval(() => {
                      this.tbdwJmDetail(obj)
                    }, 2000);
                }else{
                    this.$message({
                        type:'error',
                        message:res.data.meta.message
                    })
                }
                this.waitLoading=false
                this.$refs.jmCom.waitLoading = false
                this.form.password='';
            }).catch(()=>{})
        },
        ewmQd(){
            this.$message({
                type:'success',
                message:'解密成功！'
            })
            this.visible=false;
            clearInterval(this.intervalTbjm);
            this.intervalTbjm=null;
            this.getData();
            let obj={
                lx:'tb',
                data:{
                    index:2,
                    msg:'2',
                    all:true
                }
            }
            this.$emit('send',JSON.stringify(obj));
        },
        //计算剩余时间倒计时
        tbjmshenyuFun(){
            var _this=this;
            var time=_this.shenyu;
            clearInterval(_this.intervalTbjm);
             _this.intervalTbjm=null;
            _this.intervalTbjm=setInterval(function(){
                if(time<1000){
                    clearInterval(_this.intervalTbjm);
                    _this.intervalTbjm=null;
                    if(!_this.sfjm){
                        _this.jmsj='<span class="red">未解密</span>';
                        let obj={
                            lx:'tb',
                            data:{
                                index:2,
                                msg:'3',
                                all:false
                            }
                        }
                        _this.$emit('send',JSON.stringify(obj))
                    }
                    _this.dialogBj=false;

                    return;
                }
                time=time-2000
            },2000)
        },
        //向主持人申请开放补救功能
        sqbj(){
            let para={}
            this.waitLoading=true
            this.$api.sqbj(para).then(res=>{
                if(res.data.meta.success){
                    let obj={
                        lx:'sqbj',
                        data:{}
                    }
                    this.$emit('send',JSON.stringify(obj))
                    this.$message({
                        type:'success',
                        message:'申请成功'
                    })
                }else{
                    this.$message({
                        type:'error',
                        message:res.data.meta.message
                    })
                }
                this.waitLoading=false
            }).catch(()=>{})
        },
        //补救弹窗
        bj(){
            this.dialogBj=true;
        },
        saveBj(){
            let para={
                tbwjId:this.tbwjId,
                bidfilesId:this.bidfilesId,
                sftbr:true,
            }
            this.waitLoading=true
            this.$api.saveBj(para).then(res=>{
                if(res.data.meta.success){
                    this.$message({
                        type:'success',
                        message:'补救成功！'
                    })
                    this.dialogBj=false;
                    clearInterval(this.intervalTbjm);
                    this.intervalTbjm=null;
                    this.getData();
                    let obj={
                        lx:'tb',
                        data:{
                            index:2,
                            msg:'2',
                            all:true
                        }
                    }
                    this.$emit('send',JSON.stringify(obj))
                }else{
                    this.$message({
                        type:'error',
                        message:res.data.meta.message
                    })
                    this.bidfilesId='';
                }
                this.waitLoading=false
            }).catch(()=>{})
        },
        //显示评分结果列表弹窗
        handleClick(tab, event){
            this.getPfjgList();
        },
        getPfjgTabs(){
            let para={}
            this.waitLoading=true
            if (this.sfchjy) {
                try {
                    this.getPfjgList();
                } finally {
                    this.waitLoading=false
                }
            } else {
                this.$api.getPfjgTabs(para).then(res=>{
                    if(res.data.meta.success){
                        if(res.data.data.kbxmpsszList.length){
                            this.pfjgTabs=res.data.data.kbxmpsszList;
                            this.activeName=this.pfjgTabs[0].lx;
                            this.pfjgDialog=true;
                            this.getPfjgList();
                        }else{
                            this.$message({
                                type:'warning',
                                message:"此项目无打分制评审!"
                            })
                        }
                    }else{
                        this.$message({
                            type:'error',
                            message:res.data.meta.message
                        })
                    }
                    this.waitLoading=false
                }).catch(()=>{
                    this.waitLoading=false
                })
            }
        },
        async getPfjgList(){
            if (this.sfchjy) {
                this.chjyTableHead = []
                this.chjyTableData = []
                let para = {
                    pageSize:10,
                    page:this.pfjgPage,
                }
                const res = await this.$api.getPfjgTabsByChjy(para)
                    if (res.data.meta.success) {
                        this.pfjgDialog = true;
                        this.chjyTableHead = res.data.data.head.map(item => {
                            const [prop, label] = Object.entries(item)[0];
                            return { prop, label };
                        });
                        this.chjyTableData = res.data.data.body
                        this.pfjgTotal = res.data.data.totalNum
                    }else {
                        this.$message({
                            type: "error",
                            message: res.data.meta.message,
                        });
        }
            } else {
                let para={
                    pageSize:10,
                    currentPage:this.pfjgPage,
                    lx:this.activeName
                }
                const res = await this.$api.getPfjgList(para)
                    if(res.data.meta.success){
                        this.pfjgList=res.data.data.dfList;
                        this.pfjgTotal=res.data.data.total
                    }else{

                    }
            }

        },
        changePfjgPage(page){
            this.pfjgPage=page;
            this.getPfjgList();
        },
        fileAdded(){
            this.bidfilesId=''
        },
        fileSuccess(obj){
            this.tbwjId=obj.tbwjId
            this.bidfilesId=obj.bidfilesId
        },
        refresh() {
            this.getPfjgTabs()
        },
        dcbb() {
            let para = {
                lx: this.activeName,
            };
            this.waitLoading = true;
            if (this.sfchjy) {
                this.$api.dcpsjgbByChjy(para).then((res) => {
                    let fileName = decodeURI(
                        res.headers["content-disposition"].split("=")[1]
                    );
                    let blob = new Blob([res.data]);
                    if (window.navigator.msSaveOrOpenBlob) {
                      navigator.msSaveBlob(blob, fileName);
                    } else {
                      let link = document.createElement("a");
                      link.href = window.URL.createObjectURL(blob);
                      link.download = fileName;
                      link.click();
                      //释放内存
                      window.URL.revokeObjectURL(link.href);
                    }
                    this.waitLoading = false;
                }).catch(() => {
                    this.waitLoading = false;
                });
            } else {
                this.$api
                  .dcpsjgb(para)
                    .then((res) => {
                      let fileName = decodeURI(
                        res.headers["content-disposition"].split("=")[1]
                      );
                      let blob = new Blob([res.data]);
                      if (window.navigator.msSaveOrOpenBlob) {
                        navigator.msSaveBlob(blob, fileName);
                      } else {
                        let link = document.createElement("a");
                        link.href = window.URL.createObjectURL(blob);
                        link.download = fileName;
                        link.click();
                        //释放内存
                        window.URL.revokeObjectURL(link.href);
                      }
                      this.waitLoading = false;
                    }).catch(() => {
                      this.waitLoading = false;
                    });
            }
        }
    },
    mounted(){
        clearInterval(this.intervalTbjm);
        clearInterval(this.progressInterval);
        this.intervalTbjm=null;
        this.progressInterval=null
        this.getData();
    },
    beforeDestroy(){
        clearInterval(this.intervalTbjm);
        clearInterval(this.progressInterval);
        this.intervalTbjm=null;
        this.progressInterval=null
        if (this.timer) {
            clearInterval(this.timer);
            this.timer = null;
        }
    }
}
</script>
<style lang="scss" scoped>
::v-deep{
  .el-progress-bar__innerText{
    color: #FFF !important;
    position: absolute;
    left:50%;
    top: 50%;
    transform: translate(-50%,-50%);
  }
  .el-progress-bar__inner{
    position: unset !important;
  }
}
.progress{
    &-layout{
        height: 260px;
        display: flex;
        flex-direction: column;
        justify-content: center;
    }
    &-text{
        text-align: center;
        font-size: 18px;
        margin-bottom: 40px;
    }
    &-item{
        width: 80%;
        margin: 0 auto;
    }
    &-btn{
        width: 100%;
        margin-top: 50px;
        display: flex;
        justify-content: center;
    }
    &-box{
        position: relative;
        .el-icon-circle-close{
            position: absolute;
            font-size: 40px;
            color:rgb(255,0,0);
            top:0;
            right: 40px;
        }
    }
}
</style>
